import React from 'react'
import { SerializedStyles, css } from '@emotion/core'
import { v4 as uuid } from 'uuid'
import { Radio } from 'antd'

type Props<T> = {
  value: T
  options: Array<{ value: T; label: string }>
  onChange: (value: T) => void
  customCss?: SerializedStyles
}

export const Segmented = <T,>(props: Props<T>) => {
  return (
    <div css={componentStyle}>
      <Radio.Group
        value={props.value}
        buttonStyle="solid"
        onChange={v => {
          props.onChange(v.target.value)
        }}
      >
        {props.options.map(opt => (
          <Radio.Button key={uuid()} value={opt.value}>
            {opt.label}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  )
}

const componentStyle = css({
  '> div': {
    display: 'flex',
    textAlign: 'center',
    '> label': {
      background: '#f5f5f5',
      color: 'rgba(0,0,0,0.65)',
      '&.ant-radio-button-wrapper-checked': {
        background: '#ffffff',
        color: 'rgba(0,0,0,0.88)',
      },
      '&.ant-radio-button-wrapper:hover': {
        color: 'rgba(0,0,0,0.88)',
        background: 'rgba(0,0,0,0.15)',
      },
      '&.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)': {
        color: 'rgba(0,0,0,0.88)',
        background: '#ffffff',
        borderColor: '#d9d9d9',
        boxShadow: '-1px 0 0 0 #d9d9d9',
        '&::before': {
          backgroundColor: '#d9d9d9 !important',
        },
        '&:hover': {
          color: 'rgba(0,0,0,0.88)',
          background: '#ffffff',
          borderColor: '#d9d9d9',
          boxShadow: '-1px 0 0 0 #d9d9d9',
        },
      },
    },
  },
})
